export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The application for collection has been completed.\n The driver of Hanjin Courier will visit you within 2 to 3 days at the address you entered when registering as a member."])}
    }
  })
}
